<template>
    <el-table-column
            :prop="prop"
            align="center"
            :label="label"
            :width="width">
            <slot></slot>
    </el-table-column>
</template>

<script>
    export default {
        name: "CommonTableColumn",
        props: {
            prop: {
                type: String,
                default: '',
                required: true,
            },
            label: {
                type: String,
                default: '',
            },
            width: {
                type: String,
            }
        }
    }
</script>

<style scoped>

</style>